import React from 'react'
import { useHistory } from 'react-router';
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";


function CoomingSoon() {
    const history = useHistory();
    let settings = {
        infinite: true,
        fade: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
    };

    return (
        <div>
            <div className="battlepass_midimg width">
                <img src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-characters-bg-2880x2241-f4710adffd1b.jpg" alt="" />
            </div>

            <div className="battle_pass_stars ">
                <img src="https://cdn2.unrealengine.com/battlepass-battlestar-277x252-579065405.png" alt="" />
            </div>

            <div className="battlepass_info">
                <p>ENTER THE SIDEWAYS
                </p>
            </div>
            <div className="battlepass__own">
                <p>COMMING SOON...</p>
            </div>

            <Carousel3 {...settings}>
                <Wrap>
                    <a>
                        <img
                            src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero---variant1-2080x2136-542e9365867d.png" alt="" />
                    </a>
                </Wrap>

            </Carousel3>

        </div>
    )
}

export default CoomingSoon

const Carousel3 = styled(Slider)`
::-webkit-scrollbar {
    width: 0;
  }
  
  margin-top: -1370px;
  margin-bottom: 220px;
 overflow-X:hidden;

  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;

    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }

  ul li button {
    &:before {
      font-size: 10px;
      color: rgb(150, 158, 171);
    }
  }

  li.slick-active button:before {
    color: white;
  }

  .slick-list {
    overflow: initial;
  }

  .slick-prev {
    left: -75px;
  }

  .slick-next {
    right: -75px;
  }
`;

const Wrap = styled.div`
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  ::-webkit-scrollbar {
    width: 0;
  }
  

  a {
    border-radius: 4px;

    cursor: pointer;
    display: block;
    position: relative;
    padding: 4px;

    img {
      width: 60%;
      margin-left:auto;
      margin-right:auto;
      

    }
`;




